<template>
  <mdb-card class="mb-4">
    <mdb-card-body class="p-2"  v-if="info">
      <mdb-row> {{isStaff}}=------
        <mdb-col md="12"><mdb-input class="my-1" label="회의명" v-model="info.name"  :disabled="!isStaff"/></mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="4">
          <date-picker v-model="info.date" label="날짜" />
        </mdb-col>
        <mdb-col md="2"><mdb-input label="시간" v-model="info.time" :disabled="!isStaff"/></mdb-col>
        <mdb-col md="5"><mdb-input label="회의 장소" v-model="info.place" :disabled="!isStaff"/></mdb-col>
      </mdb-row>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbCard, mdbCardHeader, mdbCardBody } from 'mdbvue';
import { mapGetters } from 'vuex';
export default {
  name: 'ProceedingInfo',
  components: { mdbCard, mdbCardBody },
  props: ['value'],
  data: function () {
    return {
      info: this.value ? this.$clone(this.value) : {}
    }
  },
  computed: mapGetters('auth', ['isStaff']),
  methods: {
  },
  watch: {
    value () {
      this.info = this.value ? this.$clone(this.value) : {}
    }
  }
}
</script>
